const openExternalLink = (link: string) => {
  window.open(link, '_blank');
};

const openInstagram = () => {
  window.open('https://www.instagram.com/permika.van', '_blank');
};

const openYoutube = () => {
  window.open('https://www.youtube.com/@permikavancouver5643', '_blank');
};

const openDiscord = () => {
  window.open('https://discord.com/invite/nSub8bbGHr', '_blank');
};

const openFacebook = () => {
  window.open('https://www.facebook.com/permika.van', '_blank');
};

const openTiktok = () => {
  window.open('https://www.tiktok.com/@permika.van', '_blank');
};

const openWhatsapp = () => {
  window.open('https://chat.whatsapp.com/BxrOC7hOZGI45kDYNCOqr9', '_blank');
};

export {
  openExternalLink,
  openInstagram,
  openYoutube,
  openDiscord,
  openFacebook,
  openTiktok,
  openWhatsapp,
};
